import { render, staticRenderFns } from "./CfgSistemasAplicativos.vue?vue&type=template&id=dc231e66&scoped=true"
import script from "./CfgSistemasAplicativos.vue?vue&type=script&lang=js"
export * from "./CfgSistemasAplicativos.vue?vue&type=script&lang=js"
import style0 from "./CfgSistemasAplicativos.vue?vue&type=style&index=0&id=dc231e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc231e66",
  null
  
)

export default component.exports